// extracted by mini-css-extract-plugin
export default {"title":"Uploader_title__WKvdk","main":"Uploader_main__amUkW","dropzone":"Uploader_dropzone__F3c0V","plus-icon":"Uploader_plus-icon__L01O1","info":"Uploader_info__U0-+2"};